module.exports = __webpack_public_path__ + "static/media/badge_flat.35ceb5e4.jpg";